import { addCoreAgentConversationTitles } from './titles/actions';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getConversations } from '@api';

export const getCoreAgentConversationsSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ (page) => addCoreAgentConversationTitles(page.items) ]
	},
	name: 'coreAgentConversations',
	receive: true,
	request: true,
	requestHandler: getConversations,
	retainDataOnRequest: true
});
